var React = require('react');

function Ball28 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.189,0,16.622,50l42.567,50,42.567-50Z","transform":"translate(-16.622)"}));
}

Ball28.defaultProps = {"viewBox":"0 0 85.133 100"};

module.exports = Ball28;

Ball28.default = Ball28;
